import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_NAME, getCanonicalOrigin, defaultOgImageUrl } from '../../config/seoConfig';

/**
 * Per-route SEO: title, description, Open Graph, Twitter, canonical.
 */
function SeoHead({
  title,
  description,
  keywords,
  canonicalPath,
  ogType = 'article',
  ogImage,
}) {
  const origin = getCanonicalOrigin().replace(/\/$/, '');
  const canonical = canonicalPath ? `${origin}${canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`}` : null;
  const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const imageUrl = ogImage || defaultOgImageUrl();

  return (
    <Helmet>
      <title>{pageTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={pageTitle} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={imageUrl} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={imageUrl} />
      {canonical ? <meta name="twitter:url" content={canonical} /> : null}
    </Helmet>
  );
}

export default SeoHead;
